export const IconFlagLt = ({ width = 20, height = 20 }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='20' height='6.666' fill='#FFCE31' />
    <rect y='6.666' width='20' height='6.666' fill='#699635' />
    <rect y='13.333' width='20' height='6.666' fill='#C94747' />
  </svg>
);
